'use client';

import { Trans } from '@lingui/macro';
import { Container, Stack, Typography } from '@mui/material';
import { Button, Center } from '@prismo-io/design-system';
import type { FC } from 'react';
type Props = {
  reset: () => void;
};
export const UserNotFoundScreen: FC<Props> = props => {
  const {
    reset
  } = props;
  return <Center data-sentry-element="Center" data-sentry-component="UserNotFoundScreen" data-sentry-source-file="index.tsx">
      <Container maxWidth="sm" data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <Stack spacing={5} alignItems="center" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
          <Typography variant="h1" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Utilisateur inconnu</Trans>
          </Typography>
          <Stack spacing={3} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
            <Typography variant="h2" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">
                Nous sommes désolés, mais le profil que vous essayez d'afficher
                n'existe&nbsp;pas.
              </Trans>
            </Typography>
          </Stack>
          <Button onClick={() => reset()} variant="contained" color="gradient" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Retourner à l'accueil</Trans>
          </Button>
        </Stack>
      </Container>
    </Center>;
};